import type { ResponseRowIssue } from './response-mapping';
import styles from './ResponseMapping.module.css';
import toolFormStyles from './ToolForm.module.css';

type RowIssue = Omit<ResponseRowIssue, 'index'>;

interface ResponseFieldCellProps {
  label: string;
  value: string;
  placeholder: string;
  list?: string;
  issue?: RowIssue;
  onChange: (value: string) => void;
}

const issueClassFor = (issue: RowIssue): string =>
  issue.isBlocking ? toolFormStyles.paramError : styles.rowWarning;

export const ResponseFieldCell = ({
  label,
  value,
  placeholder,
  list,
  issue,
  onChange,
}: ResponseFieldCellProps) => (
  <td>
    <input
      type="text"
      value={value}
      onChange={event => onChange(event.target.value)}
      className={toolFormStyles.paramNameInput}
      placeholder={placeholder}
      list={list}
      aria-invalid={issue?.isBlocking}
      aria-label={label}
    />
    {issue && <span className={issueClassFor(issue)}>{issue.message}</span>}
  </td>
);
